<template>
    <div id="start">
        <v-card
            class="centered-card"
        >
            <v-card-title>
                <strong>Willkommen bei der Registrierung<br>für den CatMessenger</strong>
            </v-card-title>
            <v-card-text>
                <div style="max-width: 30em;">
                    <p>
                        Registrieren Sie sich jetzt und nutzen Sie den CatMessenger<br>
                        <strong>3 Monate kostenlos für Ihre gesamte Schule</strong> oder Bildungseinrichtung.
                    </p>
                    <v-btn
                        color="cyan"
                        style="color: #fff; margin: 1em 0 3em 0;"
                        @click="goTo"
                    >
                        <v-icon
                            small
                            left
                        >
                            fa-arrow-right
                        </v-icon>
                        Jetzt registrieren
                    </v-btn>
                </div>
                <v-alert
                    text
                    color="purple"
                    class="list-alert"
                >
                    <div id="wrapper">
                        <div
                            id="number"
                            class="material-color-purple-500-bg material-color-purple-50-txt"
                        >
                            <span>1.</span>
                        </div>
                        <div id="content">
                            <img
                                src="./../assets/img/6.svg"
                                width="100"
                            >
                            <div class="label">
                                Ihr kostenloser Zugang zum CatMessenger startet heute
                            </div>
                            <p>
                                Gerade in Zeiten von sozialer Distanz ist und bleibt eine sichere und schnelle Kommunikation das A und O. Daher kann sich ab sofort jede Schulgemeinschaft über den CatMessenger austauschen: Der CatMessenger ist für Sie 3 Monate kostenlos, solange uns dies möglich ist*. Dabei bleiben Sie frei von Verpflichtungen - es wird kein Abo abgeschlossen. Nach 3 Monaten erlischt Ihr Zugang automatisch, wenn Sie ihn nicht verlängern wollen.
                            </p>
                        </div>
                    </div>
                </v-alert>
                <v-alert
                    text
                    color="amber darken-3"
                    class="list-alert"
                >
                    <div id="wrapper">
                        <div
                            id="number"
                            class="material-color-amber-800-bg material-color-amber-50-txt"
                        >
                            <span>2.</span>
                        </div>
                        <div id="content">
                            <img
                                src="./../assets/img/7.svg"
                                width="100"
                            >
                            <div class="label">
                                Was passiert nach 3 Monaten? 
                            </div>
                            <p>
                                Wir erinnern Sie einen Monat vor Ablauf Ihrer kostenlosen Testphase.
                                Wenn Sie den CatMessenger dann weiterhin für Ihre Institution nutzen wollen, fallen pro Benutzer 1,40€ im Jahr (zzgl. MwSt.) an. Alle bisherigen Daten und Chats bleiben dann erhalten. Vertragslaufzeit 1 Jahr, kündbar 3 Monate zu Vertragsende. 
                                Falls Sie den CatMessenger nicht weiter nutzen möchten, werden sämtliche Daten gelöscht. 
                            </p>
                        </div>
                    </div>
                </v-alert>
                <v-alert
                    text
                    color="cyan"
                    class="list-alert"
                >
                    <div id="wrapper">
                        <div
                            id="number"
                            class="material-color-amber-800-bg material-color-amber-50-txt"
                        >
                            <span>2.</span>
                        </div>
                        <div id="content">
                            <img
                                src="./../assets/img/8.svg"
                                width="100"
                            >
                            <div
                                v-show="false"
                                class="label"
                            >
                                Was passiert nach 3 Monaten? 
                            </div>
                            <p>
                                <strong>*Bedingungen für unser Giveaway</strong><br>
                                Wir wollen so vielen betroffenen Menschen wie möglich Nutzerkonten zur Verfügung stellen und für sie unseren Dienst am Laufen halten. Wir werden die kostenlosen Nutzerkonten bereitstellen, solange wir die Nachfrage bewältigen können.
                            </p>
                            <p>
                                <strong>Haftungsausschluss</strong><br>
                                Um so vielen Menschen wie möglich während des Ausbruchs von COVID-19 zu helfen, müssen wir ggf. die Auslastung der Server begrenzen. Aus diesem Grund behalten wir uns das Recht vor, die Registrierung für diese Kampagne jederzeit zu stoppen. Wir hoffen auf Ihr Verständnis.
                            </p>
                        </div>
                    </div>
                </v-alert>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'Start',
    components: {
        
    },
    data() {
        return {
        }
    },
    created(){
        
    },
    methods: {
        goTo(){
            document.location="/registration"
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/assets/css/palettes.scss";
    @import "@/assets/css/extends.scss";
    @import "@/assets/css/global.scss";

    div#start{
        display: flex;
        justify-content: center;

        p{
            margin: .5em 0;
            &.subtext{
                margin: .5em 0 2em 0;
            }
        }
        a {
            &.dark{
                color: #fff;
            }
        }
        div.centered-card{
            max-width: 800px;
            margin: 2em 0;
            @include mediaQueryCutMax(xs){
                margin: 0;
                width: 100%;
                min-height: calc(100vh - 3em);
            }
        }
        div.v-alert.list-alert{
            max-width: 30em;
            div#wrapper{
                position: relative;
                > div#number{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 2em;
                    height: 2em;
                    border-radius: 50%;
                    // background-color: palette(Amber, 800);
                    color: palette(Amber, 100);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    display: none;
                    > span{
                        position: relative;
                        left:1px;
                    }
                }
                > div#content{
                    display: flex;
                    flex-direction: column;
                    > img{
                        align-self: center;
                        margin-bottom: 1em;
                    }
                    > div.label{
                        font-weight: bold;
                        margin: .25rem 0 .5rem 0;
                        font-size: 1.25em;
                        align-self: center;
                    }
                }
            }
        }
    }
</style>